import React, { ComponentType, ReactFragment } from 'react';
import { hydrate, render } from 'react-dom';
import { createGenerateId, JssProvider, SheetsRegistry } from 'react-jss';
import { BugsnagErrorBoundary } from '@bugsnag/plugin-react';

function singleToolRenderSeo(
  rootId: string,
  app: JSX.Element,
  ErrorBoundary: BugsnagErrorBoundary | ComponentType<ReactFragment>,
  APP_VERSION: string,
  APP_NAME: string,
) {
  const rootElement = document.getElementById(rootId || 'root');
  const REACT_SNAP_STYLES = 'react-snap-styles';

  if (rootElement && rootElement.hasChildNodes()) {
    hydrate(
      <ErrorBoundary>
        <React.StrictMode>{app}</React.StrictMode>
      </ErrorBoundary>,
      rootElement,
      () => {
        const reactSnapStyles = document.getElementById(REACT_SNAP_STYLES);
        reactSnapStyles?.parentNode?.removeChild(reactSnapStyles);
      },
    );
  } else {
    const registry = new SheetsRegistry();
    const generateId = createGenerateId();

    render(
      <ErrorBoundary>
        <React.StrictMode>
          <JssProvider registry={registry} generateId={generateId}>
            {app}
          </JssProvider>
        </React.StrictMode>
      </ErrorBoundary>,
      rootElement,
      () => {
        if (navigator.userAgent === 'ReactSnap') {
          const head = document.querySelector('head');
          const style = document.createElement('style');

          style.innerHTML = registry.toString();
          style.setAttribute('id', REACT_SNAP_STYLES);
          head.appendChild(style);

          setTimeout(() => {
            const badStyles = document.querySelectorAll('[data-jss]');
            badStyles.forEach((cssStyle) => cssStyle.parentNode?.removeChild(cssStyle));
          }, 0);
        }
      },
    );
  }

  console.log('App name:', APP_NAME);
  console.log('Using version: ', APP_VERSION);
  console.log('Config version: ', process.env.NODE_ENV);
}

export default singleToolRenderSeo;
